module.exports = __webpack_public_path__ + "7d94c2fe3244e74118f3e53ee6dd0943.png";